module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form id="' +
((__t = (id)) == null ? '' : __t) +
'" class="form-horizontal">\n    <div class="form-group row">\n		';
 if (projection) {;
__p += '\n		<label class="DescartesUILabel col-md-4 col-lg-4 col-form-label">\n			Projection\n		</label>\n		<div class="col-md-8 col-lg-8">\n    		';
 if (projectionsCodesValues.length === 1) {;
__p += '\n				<label  class="DescartesUILabel col-form-label">' +
((__t = (projectionsCodesValues[0].value)) == null ? '' : __t) +
'</label>\n			';
} else {;
__p += '\n        		<select class="DescartesUISelect form-control" name="' +
((__t = (id)) == null ? '' : __t) +
'_input_proj" id="' +
((__t = (id)) == null ? '' : __t) +
'_input_proj">\n                	';
 for (var i = 0, len = projectionsCodesValues.length; i < len; i++) { ;
__p += '\n        				<option value="' +
((__t = (projectionsCodesValues[i].code)) == null ? '' : __t) +
'" \n        				';
 if (selectedProjection === i) { ;
__p += '\n        				selected >' +
((__t = (projectionsCodesValues[i].value)) == null ? '' : __t) +
'</option>\n        				';
} else {;
__p += '\n        					>' +
((__t = (projectionsCodesValues[i].value)) == null ? '' : __t) +
'</option>\n            			';
};
__p += '\n        			';
};
__p += '\n    			</select>\n        	';
 };
__p += '\n        </div>	\n        ';
};
__p += '\n    </div>\n    <div class="form-group row">\n        <label id="coordinateslabelx" class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (x)) == null ? '' : __t) +
'</label>\n        <div class="col-sm-9">\n        	<input type="text" step="any" required="true" class="DescartesUIInput form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_input_x" name="x">\n        </div>\n    </div>\n    <div class="form-group row">\n        <label id="coordinateslabely" class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (y)) == null ? '' : __t) +
'</label>\n        <div class="col-sm-9">\n        	<input type="text" step="any" required="true" class="DescartesUIInput form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_input_y" name="y">\n        </div>\n    </div>\n    <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (buttonMessage)) == null ? '' : __t) +
'</button>\n</form>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/CoordinatesInputInPlace.ejs
// module id = 393
// module chunks = 0